import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("TeaserSliderWidget", {
  title: "Teaser Slider",
  attributes: {
    nextArrow: {
      title: "Arrow next description",
      description: "Aria label description (for screen readers)",
    },
    prevArrow: {
      title: "Arrow prev description",
      description: "Aria label description (for screen readers)",
    },
    panels: { title: "Panels" },
  },
  properties: ["panels", "nextArrow", "prevArrow"],
  initialContent: {
    nextArrow: "Nächste Seite",
    prevArrow: "Vorherige Seite",
  },
});
